import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";


export const StockAdjustmentList: React.FC = () => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<string | number>(0);
    const [isPopupOpen, setPopupOpen] = useState(false);
      const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  

  // Header
  useEffect(() => {
  updateMainHeader("Inventory");
  labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
}, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Customer Management": "/customer/list" },
  ]);

  const source = {
    url: "stock-adjustment/list",  // ✅ Fixed API path
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };
 
  const columns: IColumns[] = [
    { header: "Date", fieldName: "CreatedDate" ,type:"date"},
    { header: "Item Name", fieldName: "ItemName" },
    { header: "Warehouse", fieldName: "WarehouseName" },
    { header: "System Qty", fieldName: "SystemQty" },
    { header: "Physical Qty", fieldName: "PhysicalQty" },
    { header: "Difference", fieldName: "Difference" },
    { header: "Adjustment Reason", fieldName: "ReasonName" },
      {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        console.log("🔍 Row data:", row); 


        const AdjustmentId = row.AdjustmentId ;
        if (!AdjustmentId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid warehouse data - missing ID", "error");
          return;
        }
        
        if (action === "Edit") {
          console.log("✏️ Navigating to edit:", AdjustmentId);
          navigate(`/adjustment/${AdjustmentId}`);
        } else if (action === "Delete") {
          console.log("🗑️ Delete clicked:", AdjustmentId);
          setSelectedId(AdjustmentId);
          setPopupOpen(true);
        }
      },
    },
   
  ];

  

  const handleClick = () => {
    navigate("/adjustment");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="stockadjustmentGrid"
            title="Stock Adjustment"
            headerType="modern"
            columns={columns}
            source={source}
            rowsPerPageCount={10}
            searchBox={{ searchMode: "query" }}
            addButton={{ label: "Add New Item", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
       <ConfirmationPopup
          type="DELETE"
          apiUrl="stock-adjustment"  
          id={selectedId}
          confirmMessage="Are you sure you want to delete this Stock Adjustment?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("stockadjustmentGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.detail, "error");
            }
          }}
        />
    </Grid>
  );
};